
const initialState = {
    loading: false,
    newPass: false,
    error: false,
    faqsListing:[],
    faqsDetail:null
  };
  
  const faqsReducer = (state = initialState, action) => {
    // console.log("faqs  reducers------", state,action);
   switch (action.type) {
     case "ADD_FAQS_REQUEST":
       return {
         ...state,
         loading: true,
       };
     case "ADD_FAQS_SUCCESS":
       return {
        ...state,
         loading: false,
         newPass: true,
         error: false,
       };
     case "ADD_FAQS_FAILED":
       return {
        ...state,
         loading: false,
         newPass: false,
         error: true,
       };

       case "GET_FAQS_REQUEST":
        return {
          ...state,
          loading: true,
        };
      case "GET_FAQS_REQUEST_FAILED":
        return {
          ...state,
          error: true,
        };
      case "GET_FAQS_REQUEST_SUCCESS":
        return {
          ...state,
          faqsListing: action.payload,
          loading:false,
        };

      case "GOT_FAQS_DETAIL":  
      return {
        ...state,
        faqsDetail: action.payload,
      };
     default:
       return state;
   }
  };
  
  export default faqsReducer;
  